import { useTranslation } from 'react-i18next';
import cc from 'classcat';
import { ICON_SIZE } from 'utils/constants/app/ui';
import { isMobile } from 'utils/is-mobile';
import {
  EAdvancedCouponsLayouts,
  EAdvancedEventsLayouts
} from 'interfaces/sportsbook';
import { GlobalIcon } from 'components/GlobalIcon';
import { updateQuery } from 'components/QueryRoute';
import { useCustomHistory } from 'newhooks/generic/useCustomHistory';
import './index.less';

export const AdvancedCouponsLayout = () => {
  const { t } = useTranslation();
  const { push } = useCustomHistory();

  const handleLayoutClick = (layout: EAdvancedCouponsLayouts) => {
    if (layout === EAdvancedCouponsLayouts.upcomingMatches) {
      push(updateQuery({ layoutType: EAdvancedEventsLayouts.upcoming }));

      return;
    }

    push(updateQuery({ coupon: layout }));
  };

  return (
    <div className="advancedCouponsLayout">
      <div
        className={cc([
          'advancedCouponsLayout__title',
          { 'advancedCouponsLayout__title--mobile': isMobile() }
        ])}
      >
        {t('sportsbook.coupons')}
      </div>
      <div
        className={cc([
          'advancedCouponsLayout__content',
          { 'advancedCouponsLayout__content--mobile': isMobile() }
        ])}
      >
        {Object.values(EAdvancedCouponsLayouts).map(layout => (
          <div
            className={cc([
              'advancedLayoutCouponCard',
              { 'advancedLayoutCouponCard--mobile': isMobile() }
            ])}
            key={layout}
            onClick={() => handleLayoutClick(layout)}
          >
            <span className="advancedLayoutCouponCard__iconWrapper">
              <GlobalIcon
                color="var(--v3-primary-color)"
                lib="generic"
                theme="default"
                name={layout}
                size={isMobile() ? ICON_SIZE.MOBILE_24 : ICON_SIZE.DESKTOP_28}
              />
            </span>
            <span
              className={cc([
                'advancedLayoutCouponCard__title',
                { 'advancedLayoutCouponCard__title--mobile': isMobile() }
              ])}
            >
              {t(`sportsbook.${layout}`)}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};
